export const getCurrentUserProfile = state =>
  state.authReducer.getIn(['userInfo', 'data', 'profile']);
